


























































































import { UserCreditData, MarketBannerAdvData } from '@/pages/home/types';
import { HaiXiaoQueryStatusType } from '@/api/homeV2Status/types';
import {
  defineComponent,
  PropType,
  computed,
  onMounted,
} from '@vue/composition-api';
import store from '@/store';
import { CallbackType } from '@/api/rights/types';
import RepayItem from '@/views_v2/home/components/repay-item/index.vue';
import { styleNumPxToVm } from '@/shared/utils/style-unit';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { TP_HOME_FINANCE_CARD_EXPOSE } from '@/pages/home/tianqi';
import { UBT_COMMON_HOME_PAGE_SIGN } from '@/pages/home/constant';
import { ModuleConfig } from '@/pages/home/config/types';
import { getCreditedQuotaStatus, getUserHomeScene } from '@/pages/home/utils';
import type { BusinessInfoExtra } from '@/api/common/types';
import FinanceCardTopBars from './components/FinanceCardTopBars/index.vue';
import MajorQuotaText from './components/MajorQuotaText/index.vue';
import MajorAmountInfo from './components/MajorAmountInfo/index.vue';
import AdjustQuotaInfo from './components/AdjustQuotaInfo/index.vue';
import RateRemindText from './components/RateRemindText/index.vue';
import MarketBannerAdv from '../components/MarketBannerAdv/index.vue';
import ActionButtons from './components/ActionButtons/index.vue';
import IdentityExpiresBar from '../components/IdentityExpiresBar/index.vue';
import IncreaseCreditBar from '../components/IncreaseCreditBar/index.vue';
import CouponInfo from './components/CouponInfo/index.vue';
import RemarkText from './components/RemarkText/index.vue';


export default defineComponent({
  name: 'FinanceNormalCard',
  components: {
    FinanceCardTopBars,
    MajorQuotaText,
    MajorAmountInfo,
    AdjustQuotaInfo,
    RateRemindText,
    MarketBannerAdv,
    ActionButtons,
    IdentityExpiresBar,
    RepayItem,
    IncreaseCreditBar,
    CouponInfo,
    RemarkText,
  },
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
    equityRecallInfo: {
      type: Object as PropType<CallbackType>,
      required: false,
    },
    marketBannerAdv: {
      type: Object as PropType<MarketBannerAdvData>,
      required: false,
    },
    /** 是否授信中 && 挂起状态 */
    hasHangAndProgressingTask: {
      type: Boolean,
      required: true,
    },
    moduleConfig: {
      type: Object as PropType<ModuleConfig>,
      required: true,
    },
    businessInfoExtra: {
      type: Object as PropType<BusinessInfoExtra>,
      required: true,
    },
    isMiddleIncomeShow: {
      type: Boolean,
      required: true,
    },
    haiXiaoQueryData: {
      type: Object as PropType<HaiXiaoQueryStatusType>,
      required: true,
    },
  },
  setup(props) {
    /** 是否不可授信提额(自营锁客) */
    const isAutarkyForbidCredit = computed(
      () => !!store.state.userAutarkyStatus.isAutarkyForbidCredit,
    );
    /** 用户已授信的额度状态 */
    const creditedQuotaStatus = computed(() => getCreditedQuotaStatus(props.userCreditData));
    /** 是否展示提额bar：已有授信记录 && 无还款订单 && 非自营锁客 && 非海消满足条件用户 */
    const showIncreaseCreditBar = computed(
      () => (props.userCreditData.creditStatus
        && !props.userCreditData.hasOrder && !isAutarkyForbidCredit.value)
        || (!props.haiXiaoQueryData?.hideApplyCreditEntry),
    );
    /** 是否展示还款订单bar */
    const showRepayOrderBar = computed(
      () => props.userCreditData.hasOrder,
    );
    /** 是否展示底部附属卡片，如 待还款订单card、申请提额入口card */
    const showAttachedCard = computed(
      () => showRepayOrderBar.value || showIncreaseCreditBar.value,
    );
    /** 是否展示券信息，券信息卡片不展示广告卡片 */
    const showCouponInfo = computed(() => {
      const { freeCouponType, couponNameMoney, couponNameDay } = props.userCreditData;
      return freeCouponType && couponNameMoney && couponNameDay;
    });

    /** ubt埋点公共参数 */
    const ubtCommonParams = computed(() => {
      const {
        preCreditUserSource, normalPreCreditModel, freeCouponType,
      } = props.userCreditData;
      const userInfo = props.businessInfoExtra?.userInfo || {};

      const scene = getUserHomeScene(props.userCreditData);

      return {
        scene,
        preCreditUserSource,
        normalPreCreditModel,
        couponType: freeCouponType,
        label: UBT_COMMON_HOME_PAGE_SIGN,
        // 包含定价标签（pricingTag）、风险标签（risk24UserSource）等用户信息
        ...userInfo,
      };
    });

    onMounted(() => {
      ubtSetupModuleExpose(TP_HOME_FINANCE_CARD_EXPOSE, ubtCommonParams.value);
    });

    return {
      creditedQuotaStatus,
      showIncreaseCreditBar,
      showRepayOrderBar,
      showAttachedCard,
      showCouponInfo,
      ubtCommonParams,
      isAutarkyForbidCredit,
      styleNumPxToVm,
    };
  },
});
